// Patchooli Mood Constants
// Centralized constants for mood tracking, emotions, and triggers

export const MAX_IMAGE_SIZE_BYTES = 250 * 1024; // 250kb.
export const MAX_IMAGE_SIZE_KB = Math.round(MAX_IMAGE_SIZE_BYTES / 1024);

export const RECORD_PRIVACY = {
  PRIVATE: 'private',
  FRIENDS: 'friends-only',
  PUBLIC: 'public',
} as const;

/**
 * Valid mood levels for mood tracking.
 */
export const MOOD_LEVELS = {
  Great: 'Great',
  Good: 'Good',
  Okay: 'Okay',
  Low: 'Low',
  Bad: 'Bad',
} as const;

/**
 * Valid emotions that can be tracked (duplicates removed from schema).
 */
export const EMOTIONS = {
  Excited: 'Excited',
  Scared: 'Scared',
  Angry: 'Angry',
  Sad: 'Sad',
  Happy: 'Happy',
  Grateful: 'Grateful',
  Hopeful: 'Hopeful',
  Proud: 'Proud',
  Anxious: 'Anxious',
  Lonely: 'Lonely',
  Stressed: 'Stressed',
  Depressed: 'Depressed',
  Overwhelmed: 'Overwhelmed',
  Frustrated: 'Frustrated',
  Disappointed: 'Disappointed',
  Embarrassed: 'Embarrassed',
  Guilty: 'Guilty',
  Jealous: 'Jealous',
  Ashamed: 'Ashamed',
  Disgusted: 'Disgusted',
  Hurt: 'Hurt',
  Worried: 'Worried',
  Confused: 'Confused',
  Bored: 'Bored',
  Tired: 'Tired',
  Sick: 'Sick',
} as const;

/**
 * Valid triggers that can affect mood.
 */
export const TRIGGERS = {
  Work: 'Work',
  Family: 'Family',
  Friends: 'Friends',
  School: 'School',
  Home: 'Home',
  Partner: 'Partner',
  Children: 'Children',
  Pets: 'Pets',
  Other: 'Other',
} as const;

/**
 * Cookie name for storing draft mood records during the multi-step entry process.
 */
export const DRAFT_MOOD_RECORD_COOKIE_NAME = 'draft_mood_record';

// Export derived types.
export type MoodLevel = (typeof MOOD_LEVELS)[keyof typeof MOOD_LEVELS];
export type Emotion = (typeof EMOTIONS)[keyof typeof EMOTIONS];
export type Trigger = (typeof TRIGGERS)[keyof typeof TRIGGERS];
export type RecordPrivacy = (typeof RECORD_PRIVACY)[keyof typeof RECORD_PRIVACY];
